<script>
import headerMain from '../blocks/header.vue';
import HomeMainBlock from '../blocks/HomeMainBlock.vue';
import SearchEmployes from '../blocks/SearchEmployes.vue';
import SearchVakancies from '../blocks/SearchVakancies.vue';
import HowWorks from '../blocks/HowWorks.vue';
import joinUs from '../blocks/joinUs.vue';
import NumbersSetka from '../blocks/NumbersSetka.vue';
import MainFooter from '../blocks/MainFooter.vue';
export default {
  name: 'HomePage',
  components: {
    headerMain,
    HomeMainBlock,
    SearchEmployes,
    SearchVakancies,
    HowWorks,
    joinUs,
    NumbersSetka,
    MainFooter
  }
}
</script>

<template>

  <div class="home">
    <headerMain />
    <HomeMainBlock />
    <SearchEmployes />
    <SearchVakancies />
    <HowWorks />
    <joinUs />
    <NumbersSetka />
    <MainFooter />
  </div>

</template>

<style scoped>
.home {
  display: flex;
  flex-direction: column;
  gap: 76px;
}
@media screen and (max-width: 991px) {
  .home {
    gap: 40px;
  }
}
</style>